import styled, {
  falconTheme,
  IFalconTheme,
  ResponsiveTypographyVariant,
  Scale,
  StyledComponent,
  typographyVariantProperties,
} from '@se-admin/falcon';

export const DiscountPriceStyle: StyledComponent<'span', IFalconTheme, {}> = styled('span')`
  align-items: center;
  display: flex;
  margin-top: 1px;
`;

DiscountPriceStyle.defaultProps = { theme: falconTheme };

export const TextWrapper: StyledComponent<'div', IFalconTheme, {}> = styled('div')`
  align-items: center;
  display: flex;
  text-align: center;
`;

export const TooltipStyle: StyledComponent<'div', IFalconTheme, {}> = styled('div')`
  margin-left: ${Scale.xxs};
  font-size: ${typographyVariantProperties[ResponsiveTypographyVariant.body].desktopFontSize};
`;
